<template>
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="main-scroll-view" style="position: relative; width: 100%; height: auto;background: url(../../assets/video-bg2.png) repeat;">


      <div class="video-list1 border-box clearfix">
        <div class="clearfix" v-for="(item,index) in voice" :key="index">
          <h3 class="video-list1-tit1">{{item.pspotname}}</h3>

          <div class="video-list1-li border-box"v-for="(ite,ind) in item.list" :key="ind" :id="'video-list-spotid'+ite.spotid">
            <h3>{{ite.number<9?'0'+parseInt(ite.number+1):parseInt(ite.number+1)}}.{{ite.spotname}}</h3>

            <div class="list1-img" @click="listenTurlClick(ite.number)">
              <img class="img" v-lazy="ite.logo" alt="" :key="ite.id">
              <p class="list1-img-mask"></p>
              <img class="list1-img-icon" :src="(ite.number==currIndex && isplay==1)?require('../../assets/btn_play_on.png'):require('../../assets/btn_play_off.png')"/>
              <span class="list1-img-time" v-if="ite.number==currIndex && isplay==1" data-id="ite.number">{{currTime|initTime}} / {{ite.totaltime|initTime}}</span>
              <span class="list1-img-time" v-else>{{ite.totaltime|initTime}}</span>
              <span class="list1-img-num" @click.stop="seeImg(0,ite.allimg)">{{ite.allimg.length}}图</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--底部播放按钮-->
    <div class="btn-video-group1 border-box" v-if="bagInfo && bagInfo.id">
      <div class="video-group1-img" :class="isplay==1?'curr':''" @click="listenTurlClick(index1,'btn')">
        <img class="img video-group1-bj" :src="bagList[index1].logo" />
        <img class="video-group1-start" src="../../assets/icon_play_btn03.png" />
        <img class="video-group1-paused" src="../../assets/icon_play_btn04.png" />
      </div>

      <div class="video-group1-info border-box">
        <p class="video-group1-tit hide">{{bagList[index1].spotname}}</p>
        <div class="video-group1-time border-box clearfix">
          <div class="video-group1-slider">
            <p ref="slider" id="slider">
              <span :style="{width:currSlider}" ></span>
              <i class="speedDot" :style="{left:currSlider}"></i>
            </p>
          </div>
          <span class="video-group1-allTime">{{bagList[index1].totaltime|initTime}}</span>
        </div>
        <div class="video-group1-btn">
          <div @click='speedFun' class="fr video-group1-ds ml45">
            <!--<div @click='rewardShowFun' class="fr video-group1-ds ml45" v-if="res.noReward!=1">-->
            <!--<img src="../../assets/icon_play_btn01.png" />-->
            <span>{{speedVideo}}</span>
            <p>倍速</p>
          </div>
          <div @click='nextVideo' class="fr video-group1-next">
            <img src="../../assets/icon_play_btn02_2.png" />
            <p>下一站</p>
          </div>
        </div>
      </div>
    </div>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import AlertReward from '../../components/AlertReward'
  import AlertComment from '../../components/AlertComment'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertFeedback from '../../components/AlertFeedback'
  import AlertPoster from '../../components/AlertPoster'
  import AlertOTA from '../../components/AlertOTA'
  import P400 from '../../components/P400'
  import {getVideoPlay, getBagComment, getZan, uploadUserBrowse, getPopComment, getOTAcode,citySiteFoodZan} from "@/service/getData";
  import {wxGetPosition,wxImgPreview, wxShareme,listenEndOrder, listenTurlVideo,listenVideo, creatOrder, pushOrder,dragSlide, TimeVideo, downVoice } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import Focus from '../../components/Focus'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)


var fromPath,fullPath;
  export default {
    data(){
      return{
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息
        currRewardShow: false,   //当前语音未弹出过打赏弹窗  true已弹出过打赏弹窗
        res:{
          isReward: false,  //未打赏过  true已打赏过
          noReward: 1 // 0自愿打赏 1关闭打赏 2强制打赏
        },//接口所有数据
        bagInfo:'',//专辑详情
        voice:[],//语音
        bagList:[],//语音列表
        commentList:[],//评论数据
        commentList1:[],//弹幕评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        memuText:'菜单',//菜单按钮文字
        menuCurr:0,//菜单按钮动画
        feedbackShow:0,//意见反馈弹窗
        isDs: false, //是否打赏过

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        isplay: 0, //当前语音是否播放
        currSlider: 0, //当前进度条
        currTime: 0, //当前播放音频的实时时间
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        action: '', //订单推送消息

        TimeStamp: new Date().getTime(),  //获取当前时间
        videoAlert:0,//导游视频弹窗
        hasVideo:0,//导游是否有视频
        video:'',//导游视频
        videoimg:'',//导游视频封面
        isVideoPlay: false,  //视频没有在播放
        commentsSwiper:0,//是否显示弹幕
        swiperOption: {
          initialSlide: 0,
          speed: 100,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: true,//开启循环模式
          direction: 'vertical',
          observeParents:true,
          observer: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
        },
        appKey:'',
        appKeyA: '',
        form: '', //来自哪个页面
        posterShow: 0, //分享海报弹窗
        OTAcode: '', //OTA激活码
        OTAcodeShow: 0, //OTA激活码弹窗
        near:[],
        paySuccess:this.$route.query.paySuccess,//是否支付成功后跳转到该页面
        system:'',//0：ios 1:android
        museumStyle:1,//是否为博物馆样式
        speedIndex:0,//音频播放倍速数组下标
        speedVideo:1.0,//音频播放倍速
        guideInfoState:0,//导游简介状态 0：两行隐藏 1：全部显示
        downloadText:'离线下载',//下载图标提示文字
        downloadTipShow:0,//下载提示是否显示

        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        downloadList:[], //存贮的音频数据
        downNum: 0, //下载个数
        downNumF: 0, //失败个数
        downMB: 0, //已下载MB
        focusRes:'',//二维码弹窗数据

        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    created() {
      this.that = this;
      this.siteid = getStore("siteid") || "";
      this.sregion = getStore("sregion") || "";
      this.id = this.$route.query.id;
      this.spotid = this.$route.query.spotid;
      this.shopid = this.$route.query.shopid;



      this.$loading.show('数据加载中');
      this.initData();


    },
    beforeDestroy(){
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },

    mounted(){

      if(fromPath == 'video-play-lz'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }

      window.addEventListener('scroll', this.commentOffsetTop)//新增
    },
    methods: {

      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");

        let res = await getVideoPlay({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          siteid: this.siteid,
          sregion: this.sregion,
          page:1,
          rows:4
        });

        if (res.errcode == "00000"){
          this.$loading.hide();
          this.res = res.data;
          this.bagInfo = res.data.bag;
          this.focusRes = res.data.bag;
          this.voice = res.data.voice;
          this.bagList = res.data.voiceList;

          for(var i=0; i<this.voice.length; i++){
            for(var j=0; j<this.voice[i].list.length; j++){
              var allimg = this.voice[i].list[j].allimg;
              if(allimg != "" && allimg != null){
                this.voice[i].list[j].allimg = allimg.split(",")
              }
            }
          }


          if(this.form == "spot"){
            this.index1 = this.getIndex(this.bagList,this.spotid);
            if(res.data.isPosition == 1){
              setTimeout(function(){
                self.scollToComment('video-list-spotid'+self.spotid,-50);
              },1000);
            }else {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
          }else if(this.global.currBag.id == this.id&&this.global.currUrl != ""){
            this.index1 = this.getIndex(this.bagList,this.global.currVoice.spotid);
            this.currIndex = this.index1
            this.isplay = this.global.playing ? 1 : 0;

            this.currTime = this.global.Audio1.currentTime;
            this.currSlider = (this.global.Audio1.currentTime / this.bagList[this.index1].totaltime) * this.global.sliderWidth + "px";

            setTimeout(function(){
              TimeVideo(self,self.bagList[self.index1].totaltime);
              self.scollToComment('video-list-spotid'+self.global.currVoice.spotid,-50);
            },800)

          }else {
            var currVoice = getStore("currVoice",1) || "";
            if(currVoice && currVoice.spotid != "" && currVoice.spotid != null && currVoice.spotid != undefined ){
              this.index1 = this.getIndex(this.bagList,currVoice.spotid);
            }
          }

          var share = res.data.share;
          let link = '/video-play-lz1?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(this.spotid){
            link = '/video-play-lz1?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid+'&form=spot&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }
          if(share == null){
            let title = '语音讲解' + this.bagInfo.shopname;
            let desc = '我是'+ this.bagInfo.guidename2 +'，让我为您讲解'+ this.bagInfo.shopname +'的历史故事';
            let img = this.bagInfo.guideheadimg2 ? this.bagInfo.guideheadimg2 : this.bagInfo.guideheadimg;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.bagInfo.shopname;


          let self = this;
          self.$nextTick(function(){
            setTimeout(function(){
              if(self.global.currUrl == ""){
                self.global.Audio1 = document.getElementById('Audio1');
                self.global.Audio1.src = self.bagList[self.index1].url;
                self.global.Audio1.preload = "auto";
                self.global.Audio1.playbackRate =  self.speedVideo;

                self.global.set_currBag(self.bagInfo)
                self.global.set_currUrl(self.bagList[self.index1].url)
                self.global.set_playSpeed(self.speedVideo)
              }
              dragSlide(self);
            },800)
          })
          self.global.set_shopStyle("pavilion")

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },


      //播放倍速
      speedFun(){
        let speedArr = [1.0,1.2,1.5,2.0];
        this.speedIndex++;
        this.speedVideo = speedArr[this.speedIndex];

        if(this.speedIndex == speedArr.length){
          this.speedIndex = 0;
          this.speedVideo = 1.0;
        }
        this.global.Audio1.playbackRate =  this.speedVideo;
        this.global.set_playSpeed(this.speedVideo);
      },


      //页面滑动到指定标签id位置
      scollToComment(elmid,top){
        MtaH5.clickStat("video_play_icon_comment");
        let self = this;
        self.$nextTick(function() {
          var dom = document.getElementById(elmid);
          if(dom && dom != null){
            if(top){
              window.scrollTo(0,Number(self.offSet(dom)+top));
            }else {
              window.scrollTo(0,self.offSet(dom));
            }
          }
        });
        self.commentsSwiper = 0;//新增判断是否显示评论弹幕
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },


      //点击一下曲
      nextVideo(){
        let currIndex = (this.currIndex == this.bagList.length -1) ? 0 : (parseInt(this.currIndex) + 1);
        listenVideo(this,currIndex);
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind,btn){
        listenVideo(this,ind);
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid){
        let result;
        if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotid == spotid){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },


      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },


    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){

        }
      }
    },
    components: {
      wxConfirm,
      Focus,
      P400
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>=1000){
          num = '1000+'
        }
        return num;
      }
    },

    destroyed () {//新增离开该页面需要移除监听评论距离顶部距离属性
      window.removeEventListener('scroll', this.commentOffsetTop)
    },
  }

</script>


<style scoped>
  @import '../../style/alert.css';

  .page{min-height: 100vh; padding-bottom: 1.8rem;  background: #1a1a1a url(../../assets/video-bg2.png) repeat; }

  /*普通列表样式*/
  .bottom-btn-box{position:fixed;left:0;bottom:0;width:100%;height:1.14rem;background: #fff;z-index:1;box-shadow:0 0 .05rem #ddd;}
  .bottom-btn{ position: relative; display: block; height:1.14rem;line-height:1.14rem;color:#fff;background: #f6a931;z-index:1;text-align:center;font-size:.36rem;letter-spacing:.04rem;}
  .video-listen{position:relative;width:1.50rem;height:1.14rem;}
  .video-listen span{position:absolute;top:.22rem;left:initial;right:16%;padding:.03rem .07rem;font-size:.18rem;color:#fff;background:#f96900;border-radius:.10rem;min-width:.24rem;text-align:center;}
  .btn-video-box.box1 .video-listen{position:absolute;left:0;top:50%;width:1.20rem;height:.45rem;-webkit-transform:translateY(-50%);transform:translateY(-50%);}
  .btn-video-box.box1 .video-listen span{position:absolute;top:-.20rem;left:initial;right:.12rem;padding:.03rem .10rem;font-size:.20rem;color:#fff;background:#f6a931;border-radius:.10rem;}
  .icon_play_num{position:absolute;top:50%;left:50%;width:.54rem;height:.50rem;margin:0 auto;transform:translate(-50%,-50%);}

  /*临展样式*/
  .video-list1{position:relative; padding: .24rem .15rem;  }
  .video-list1-tit1{ margin-top: .56rem; font-size: .3rem; line-height: .36rem; color: #fff;text-align: center;}
  .video-list1-li{ margin-bottom: .45rem; padding: 0 .15rem; width: 50%; float: left; }
  .video-list1-li > h3{ font-weight: normal; font-size: .24rem; line-height: .3rem; color: #f6a931; margin-top: .2rem; }
  .list1-img{ position: relative; margin-top: .15rem; width: 100%; height: 2.5rem; border-radius: .1rem; overflow: hidden; }
  .list1-img .img{ background: url(../../assets/loadimg.png) no-repeat center; background-size: 35% auto; }
  .list1-img-icon{ position: absolute; left: 50%; top: 50%; z-index: 1; margin: -.55rem 0 0 -.32rem; width: .64rem; height: .64rem; }
  .list1-img-num{position: absolute; right: .25rem; bottom: .2rem; z-index: 1; width: .88rem; height: .44rem; line-height: .44rem; font-size: .24rem; color: #fefefe; text-align: center; background-color: rgba(0,0,0,.4); border-radius: .44rem; }
  .list1-img-time{position: absolute; left: .23rem; bottom: .24rem; z-index: 1; font-size: .24rem; color: #fefefe; }
  .list1-img-mask{position: absolute;left: 0; top: 0; z-index: 1; width: 100%; height: 100%; background-color: rgba(0,0,0,.3); }


  /*底部播放按钮组*/
  .btn-video-group1{ position: fixed; left: .08rem; right: .08rem; bottom: 0; z-index: 8; height: 1.42rem; padding: .14rem .33rem .17rem 1.44rem; box-shadow: 0 0 .10rem .05rem #000; background: #1a1a1a; border-radius: .10rem;  }
  .video-group1-img{ position: absolute; left: .18rem; top: .15rem; width: 1.10rem; height: 1.10rem; border-radius: 50%;overflow: hidden; }
  .video-group1-bj{ width: 100%; height: 100%; }
  .video-group1-start,.video-group1-paused{ position: absolute; left: .19rem; top: .19rem; z-index: 1; width: .72rem; height: .72rem; }
  .video-group1-paused{ display: none; }
  .video-group1-img.curr .video-group1-start{ display: none; }
  .video-group1-img.curr .video-group1-paused{ display: block; }
  .video-group1-info{ position: relative; width: 100%; height: 1.10rem; padding-right: 2.60rem; }
  .video-group1-tit{ font: normal .30rem/.40rem "Microsoft YaHei"; color: #999; }
  .video-group1-time{ position: relative; padding-right: .76rem; margin-top: .2rem; height: .30rem; }
  .video-group1-slider{ position: relative; width: 84%; margin: 0 auto; padding-top: .12rem; }
  .video-group1-slider p{ position: relative; width: 100%; height: .05rem; background-color: #333; border-radius: .05rem; }
  .video-group1-slider p span{ position: absolute; left: 0; top: 0; z-index: 1; width: 100%; height: .05rem; background-color: #f6a931; border-radius: .05rem; }
  .video-group1-slider p i{position: absolute; left: 0; top: -.29rem; z-index: 1; margin-left: -.45rem; width: .9rem; height: .6rem; background: url(../../assets/icon_play_btn12.png) no-repeat; background-size: 100% 100%; }
  .video-group1-allTime{ position: absolute; right: 0; top: 0; z-index: 1; height: .30rem; font: .22rem/.30rem "Microsoft YaHei"; color: #535861; }
  .video-group1-btn{ position: absolute; right: 0; top: 0; width: 2.60rem; height: 1.10rem; }
  .video-group1-btn div{ display: inline-block; width: .78rem; height: 1.10rem; text-align: center; }
  .video-group1-btn div img{ display: block; width: .78rem; height: .78rem; }
  .video-group1-btn div p{ display: block; width: .78rem; font: .20rem/.36rem "Microsoft YaHei"; color: #f6a931; }
  .video-group1-ds span{display: block; width: .6rem; height: .6rem; font: .26rem/.6rem Microsoft YaHei; color: #f6a931; margin: .01rem auto 0.08rem; border: .04rem solid #f6a931; border-radius: 50%;text-align: center;}






</style>



// WEBPACK FOOTER //
// src/page/video-play/video-play-lz1.vue